import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "../../../../services/common.service";
import { AppConfig } from "../../../../configs/app";
import { PlanService } from "../../../../services/plan.service";
import { CacheService } from "../../../../services/cache.service";
import { AnalyticsService } from "../../../../services/analytics.service";

@Component({
  selector: "page-plan-list",
  templateUrl: "./list.component.html",
})
export class PagePlanListComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public searchParams: any = {};
  public filterData: any = {};

  public bestPriceList: any = {
    thisMonth: {},
    nextMonth: {},
  };

  public planList: any = [];
  public viewedPlans: any = {};
  public favouritePlans: any = {};
  public pagination: any = {};
  public activatedStation: any = {};
  public targetDay: string;
  public viewingDate: string;
  public calendarDate: string;
  public hasTargetDay: boolean;
  public monthJustChanged: boolean;
  public initDate: string; /* AS SELECTED/ACTIVE DATE */
  public city: string;
  public town: string;
  public services: any = [];
  public office: string;

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public appConfig: AppConfig,
    public commonService: CommonService,
    public planService: PlanService,
    public cacheService: CacheService,
    private analyticsService: AnalyticsService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();

    /*
            SET INIT DATE
            IF NOW IS GREATER THAN 18, SET INIT DATE TO THE NEXT DAY
        */
    if (this.moment().hour() < 18) {
      this.initDate = this.moment().format("YYYYMMDD");
    } else {
      this.initDate = this.moment().add(1, "days").format("YYYYMMDD");
    }
    /* END */
    this.targetDay = this.initDate;
    this.hasTargetDay = false;
    this.viewingDate = this.initDate;
    // 【2026-08-01修正】価格カレンダーの取得起点は「実際の今日」に固定。
    // initDate(18時以降=翌日)起点だと月末日の18時以降に当月データが取得されず
    // 当日が選択不可になるため(詳細はlayout-partial.component.tsの同修正コメント参照)。
    this.calendarDate = this.moment().format("YYYYMMDD");
    this.monthJustChanged = true;

    /* FILTER DATA */
    this.filterData = {
      targetDay: this.targetDay,
      isViewingCalendar: false,
      cityChoosingType: "departure",
      sort: 1,

      bestPriceList: {
        thisMonth: {},
        nextMonth: {},
        next2Month: {},
        next3Month: {},
      },

      divisionData: {},
      townData: {
        departure: {},
        destination: {},
      },

      departureYMD: this.targetDay,
      departureCityID: "",
      destinationCityID: "",
      departureTownID: "",
      destinationTownID: "",

      /* PLAN OPTIONS */
      planOptions: this.planService.getPlanOptions(),
      chosenOptions: {},
      tempChosenOptions: {},
    };

    /* VIEWED & FAVOURITE PLANS */
    this.viewedPlans = {
      keyMap: {},
      list: [],
    };

    this.favouritePlans = {
      keyMap: {},
      list: [],
    };

    /* PAGINATION */
    this.pagination = {
      offset: 0,
      limit: this.appConfig.plan.searchPageLimits,
      totalPlans: 0,
      currentPage: 1,
      hasPrev: false,
      hasPrevDay: false,
      hasNext: false,
      lastItemSeq: "-",
    };

    /* TEMP DATA */
    this.tempData.loadingPlanList = true;
  }

  async ngOnInit() {
    /* SET PAGE TITLE */
    this.commonService.setTitle(
      "夜行・高速バス 比較 | バス格安予約のバスブックマーク"
    );

    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET PLAN DATA */
    let targetDay = this.activatedRoute.snapshot.paramMap.get("targetDay");
    this.targetDay = targetDay;
    this.city = this.activatedRoute.snapshot.paramMap.get("city");
    this.town = this.activatedRoute.snapshot.paramMap.get("town");
    this.office = this.activatedRoute.snapshot.paramMap.get("office");

    /* ANALYTIC SERVICES PARAM (SEAT TYPE, OTHERS, ...) */
    this.analyticPlanServices();

    if (
      targetDay &&
      this.moment(targetDay, "YYYYMMDD", true).isValid() === true
    ) {
      if (this.moment(targetDay, "YYYYMMDD").valueOf() <= this.moment(this.moment(), "YYYYMMDD").valueOf()) {
        //過去日検索の場合は、現在日を設定
        this.targetDay = this.moment().format("YYYYMMDD");
      } else {
        this.targetDay = targetDay;
      }
      this.hasTargetDay = true;
      this.viewingDate = targetDay;
    } else {
      this.targetDay = this.initDate;
      this.hasTargetDay = false;
      this.viewingDate = this.initDate;
    }

    /* IN CASE WE HAVE 1 PARAM, AND IT IS city NOT targetDay  */
    if (!this.commonService.isNumeric(targetDay) && !this.city && !this.town) {
      this.city = targetDay;
    }

    /* INIT SEARCH & FILTER DATA */
    await this.initSearchNFilterData();

    this.monthJustChanged = true;
    await this.getPlanList();

    /* VIEWED & FAVOURITE PLANS */
    this.getViewedPlans();
    this.getFavouritePlans();

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  async initSearchNFilterData() {
    /* SEARCH PARAMS */
    this.searchParams = {
      departureYMD: this.targetDay,
      departureCityID: "",
      destinationCityID: "",
      departureTownID: "",
      destinationTownID: "",
      planOptions: "",
      offset: this.pagination.offset,
      limit: this.pagination.limit,
      sort: 1 /* 1:料金安い順 2:料金高い順 3:出発時刻早い順 4:出発時刻遅い順 省略時は1 */,
      office: "",
    };

    /* GET SAVED FILTER DATA */
    let savedFilterData = this.planService.getFilterOptions();
    if (!this._.isEmpty(savedFilterData)) {
      if (
        !this.hasTargetDay &&
        this.moment(savedFilterData.departureYMD).valueOf() >
          this.moment(this.targetDay).valueOf()
      ) {
        this.targetDay = savedFilterData.departureYMD;
        this.searchParams.departureYMD = this.targetDay;
        this.viewingDate = this.targetDay;
      }
      if (this._.has(savedFilterData, "isReturn")) {
        if (savedFilterData.isReturn) {
          this.searchParams.departureCityID = savedFilterData.destinationCityID;
          this.searchParams.destinationCityID = savedFilterData.departureCityID;
          this.searchParams.departureTownID = savedFilterData.destinationTownID;
          this.searchParams.destinationTownID = savedFilterData.departureTownID;
        }
      } else {
        this.searchParams.departureCityID = savedFilterData.departureCityID;
        this.searchParams.destinationCityID = savedFilterData.destinationCityID;
        this.searchParams.departureTownID = savedFilterData.departureTownID;
        this.searchParams.destinationTownID = savedFilterData.destinationTownID;
      }

      this.searchParams.planOptions = savedFilterData.planOptions;
      this.searchParams.sort = savedFilterData.sort;

      this.filterData.chosenOptions = savedFilterData.chosenOptions;
      this.filterData.townData = savedFilterData.townData;

      this.searchParams.office = savedFilterData.office;
    }

    /* ANALYTIC SERVICES PARAM (SEAT TYPE, OTHERS, ...) */
    if (!this._.isEmpty(this.services)) {
      /* TEMP REMOVED :: this.filterData.chosenOptions["シートタイプ"] = {}; */
    }
    for (let service of this.services) {
      /* SEAT TYPES */
      /* seat_standard,seat_relax,seat_three,seat_twoplusone */
      if (service.indexOf("seat_standard") !== -1) {
        this.filterData.chosenOptions["シートタイプ"]["0"] = "10101";
      } else if (service.indexOf("seat_relax") !== -1) {
        this.filterData.chosenOptions["シートタイプ"]["1"] = "10102";
      } else if (service.indexOf("seat_three") !== -1) {
        this.filterData.chosenOptions["シートタイプ"]["2"] = "10104";
      } else if (service.indexOf("seat_twoplusone") !== -1) {
        this.filterData.chosenOptions["シートタイプ"]["3"] = "10105";
      }
    }
    /* END */

    /* GET DIVISION DATA */
    this.filterData.divisionData = await this.planService.getDivisions();
    /* END */

    /* SET CITY & TOWN DATA FROM URL PARAM */
    /* CITY */
    if (!this._.isEmpty(this.city)) {
      let cityArr = this.city.split("_");
      if (cityArr.length === 1) {
        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[0]}`
          )
        ) {
          this.searchParams.departureCityID =
            this.filterData.divisionData.division_map.slug[cityArr[0]].id_bb;
          this.searchParams.destinationCityID = "";
        } else {
          this.searchParams.departureCityID = "";
          this.searchParams.destinationCityID = "";
        }
      } else if (cityArr.length > 1) {
        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[0]}`
          )
        ) {
          this.searchParams.departureCityID =
            this.filterData.divisionData.division_map.slug[cityArr[0]].id_bb;
        } else {
          this.searchParams.departureCityID = "";
        }

        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[1]}`
          )
        ) {
          this.searchParams.destinationCityID =
            this.filterData.divisionData.division_map.slug[cityArr[1]].id_bb;
        } else {
          this.searchParams.destinationCityID = "";
        }
      }
    }

    /* TOWN */
    if (!this._.isEmpty(this.town)) {
      let townArr = this.town.split("_");
      if (townArr.length === 1) {
        this.filterData.cityChoosingType = "departure";
        await this.getTowns(this.searchParams.departureCityID, false);
        if (
          this._.has(
            this.filterData.townData,
            `departure.map.slug.${townArr[0]}`
          )
        ) {
          this.searchParams.departureTownID =
            this.filterData.townData.departure.map.slug[townArr[0]].id;
          this.searchParams.destinationTownID = "";
        } else {
          this.searchParams.departureTownID = "";
          this.searchParams.destinationTownID = "";
        }
      } else if (townArr.length > 1) {
        this.filterData.cityChoosingType = "departure";
        await this.getTowns(this.searchParams.departureCityID, false);
        this.filterData.cityChoosingType = "destination";
        await this.getTowns(this.searchParams.destinationCityID, false);
        if (
          this._.has(
            this.filterData.townData,
            `departure.map.slug.${townArr[0]}`
          )
        ) {
          this.searchParams.departureTownID =
            this.filterData.townData.departure.map.slug[townArr[0]].id;
        } else {
          this.searchParams.departureTownID = "";
        }

        if (
          this._.has(
            this.filterData.townData,
            `destination.map.slug.${townArr[1]}`
          )
        ) {
          this.searchParams.destinationTownID =
            this.filterData.townData.destination.map.slug[townArr[1]].id;
        } else {
          this.searchParams.destinationTownID = "";
        }
      }
    } else if (!this._.isEmpty(this.city)) {
      this.searchParams.departureTownID = "";
      this.searchParams.destinationTownID = "";
    }
    /* END */

    if (!this._.isEmpty(this.office)) {
      this.searchParams.office = this.office;
    }
    if (this.searchParams.office == null) {
      this.searchParams.office = this.office;
    }

    /* SET FILTER DATA */
    this.filterData.departureYMD = this.searchParams.departureYMD;
    this.filterData.departureCityID = this.searchParams.departureCityID;
    this.filterData.destinationCityID = this.searchParams.destinationCityID;
    this.filterData.departureTownID = this.searchParams.departureTownID;
    this.filterData.destinationTownID = this.searchParams.destinationTownID;
    this.filterData.sort = this.searchParams.sort;
    /* END */
  }

  analyticPlanServices() {
    let services: any = this.activatedRoute.snapshot.paramMap.get("services");

    if (!services) {
      if (this.targetDay) {
        services = this.targetDay;
      } else if (this.town) {
        services = this.town;
      } else if (this.city) {
        services = this.city;
      }
    }

    if (services) {
      services = services.split(",");

      if (services.length !== 0) {
        for (let service of services) {
          this.services.push(service);
        }
      }
    }
  }

  /* SORT */
  async applySort(type: string = "cancel", value: any = 1) {
    if (type == "apply") {
      /* CLOSE ALL MODALS */
      this.commonService.closeAllModals();

      /* SHOW LOADER */
      this.commonService.showPageLoader("読み込み中...");

      this.filterData.sort = value;
      this.searchParams.sort = parseInt(this.filterData.sort);
      this.pagination.currentPage = 1;
      await this.getPlanList();

      /* SAVE FILTER OPTIONS */
      this.saveFilter();

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    } else {
      /* CANCEL */
      this.filterData.sort = parseInt(this.searchParams.sort);
    }
  }

  /* FILTER */
  getCityName(id: any) {
    if (this._.has(this.filterData.divisionData, `division_map.id_bb.${id}`)) {
      return this.filterData.divisionData.division_map.id_bb[id].name;
    }
    return "---";
  }

  getTownName(id: any, type: any) {
    if (type == "departure") {
      if (this._.has(this.filterData.townData.departure, `map.id_bb.${id}`)) {
        return this.filterData.townData.departure.map.id_bb[id].name;
      }
    } else {
      if (this._.has(this.filterData.townData.destination, `map.id_bb.${id}`)) {
        return this.filterData.townData.destination.map.id_bb[id].name;
      }
    }
    return "---";
  }

  async getTowns(cityID: any, loadFromView: boolean = true) {
    /* SHOW LOADER */
    if (loadFromView) {
      this.commonService.showPageLoader("読み込み中...");
    }

    let townData: any = await this.planService.getTowns(cityID);
    if (this.filterData.cityChoosingType == "departure") {
      this.filterData.townData.departure = townData;

      /* CHOOSE FIRST IF EMPTY */
      if (this.filterData.departureTownID == "") {
        this.filterData.departureTownID =
          this.filterData.townData.departure.list[0].id;
      }
    } else {
      /* DESTINATION */
      this.filterData.townData.destination = townData;

      /* CHOOSE FIRST IF EMPTY */
      if (this.filterData.destinationTownID == "") {
        this.filterData.destinationTownID =
          this.filterData.townData.destination.list[0].id;
      }
    }

    /* HIDE LOADER */
    if (loadFromView) {
      this.commonService.hidePageLoader();
    }
  }

  checkActiveDivisionChildren(parent: any) {
    let returnData = false;
    if (parent && this.filterData.divisionData.division[parent]) {
      for (let item of this.filterData.divisionData.division[parent]) {
        if (
          (this.filterData.cityChoosingType == "departure" &&
            item.id_bb == this.filterData.departureCityID) ||
          (this.filterData.cityChoosingType == "destination" &&
            item.id_bb == this.filterData.destinationCityID)
        ) {
          returnData = true;
          break;
        }
      }
    }
    return returnData;
  }

  checkActivePlanOptions(index: number, heading: any) {
    if (this._.has(this.filterData.chosenOptions, `${heading}.${index}`)) {
      return true;
    }
    return false;
  }

  setPlanOptions(index: number, heading: any, code: any) {
    if (!this.filterData.chosenOptions.hasOwnProperty(heading)) {
      this.filterData.chosenOptions[heading] = {};
      this.filterData.chosenOptions[heading][index] = code;
    } else {
      if (this.filterData.chosenOptions[heading].hasOwnProperty(index)) {
        delete this.filterData.chosenOptions[heading][index];
      } else {
        this.filterData.chosenOptions[heading][index] = code;
      }
    }
  }

  getChosenPlanOptions() {
    let options = [];
    for (let heading in this.filterData.chosenOptions) {
      for (let option in this.filterData.chosenOptions[heading]) {
        options.push(this.filterData.chosenOptions[heading][option]);
      }
    }
    return this._.uniq(options).join("|");
  }

  /* OPEN FILTER */
  openFilter() {
    let departureYMD = this.searchParams.departureYMD;
    this.filterData.departureYMD = departureYMD;
    this.filterData.targetDay = this.targetDay;

    /* PLAN OPTIONS */
    this.filterData.tempChosenOptions = JSON.parse(
      JSON.stringify(this.filterData.chosenOptions)
    );
  }

  /* APPLY FILTER */
  async applyFilter() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET FILTER DATA */
    this.filterData.departureYMD = this.moment(
      this.filterData.targetDay
    ).format("YYYYMMDD");

    this.searchParams.departureYMD = this.filterData.departureYMD;
    this.searchParams.departureCityID = this.filterData.departureCityID;
    this.searchParams.destinationCityID = this.filterData.destinationCityID;
    this.searchParams.departureTownID = this.filterData.departureTownID;
    this.searchParams.destinationTownID = this.filterData.destinationTownID;

    this.filterData.tempChosenOptions = this.filterData.chosenOptions;
    /* END */

    /* SET DATA FOR GETTING LIST */
    this.pagination.currentPage = 1; /* BACK TO THE FIRST PAGE */
    this.targetDay = this.searchParams.departureYMD;
    this.viewingDate = this.searchParams.departureYMD;
    this.hasTargetDay = true;
    this.monthJustChanged = true;

    this.updateURL({
      date: this.searchParams.departureYMD,
    });

    this.analyticsService.search("list", this.searchParams, this.filterData);
    await this.getPlanList();

    /* SAVE FILTER OPTIONS */
    this.saveFilter();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  /* CANCEL FILTER */
  async cancelFilter() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET FILTER DATA */
    this.searchParams.departureYMD = this.filterData.departureYMD;

    this.filterData.departureCityID = this.searchParams.departureCityID;
    this.filterData.destinationCityID = this.searchParams.destinationCityID;
    this.filterData.departureTownID = this.searchParams.departureTownID;
    this.filterData.destinationTownID = this.searchParams.destinationTownID;

    this.filterData.chosenOptions = this.filterData.tempChosenOptions;
    /* END */

    /* await this.getPlanList(); */

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  reverseDivisions() {
    let valData = {
      departureCityID: this.filterData.departureCityID,
      destinationCityID: this.filterData.destinationCityID,
      departureTownID: this.filterData.departureTownID,
      destinationTownID: this.filterData.destinationTownID,

      townData: {
        departure: this.filterData.townData.departure,
        destination: this.filterData.townData.destination,
      },
    };

    this.filterData.departureCityID = valData.destinationCityID;
    this.filterData.destinationCityID = valData.departureCityID;
    this.filterData.departureTownID = valData.destinationTownID;
    this.filterData.destinationTownID = valData.departureTownID;

    this.filterData.townData.departure = valData.townData.destination;
    this.filterData.townData.destination = valData.townData.departure;
  }

  onFilterDateChanged(data: any) {
    this.filterData.targetDay = data.date;
  }

  saveFilter() {
    this.planService.saveFilterOptions({
      departureYMD: this.searchParams.departureYMD,
      departureCityID: this.searchParams.departureCityID,
      destinationCityID: this.searchParams.destinationCityID,
      departureTownID: this.searchParams.departureTownID,
      destinationTownID: this.searchParams.destinationTownID,
      planOptions: this.searchParams.planOptions,
      sort: this.searchParams.sort,
      chosenOptions: this.filterData.chosenOptions,
      townData: this.filterData.townData,
    });

    /* SAVE CACHE */
    this.cacheService.setData(
      this.appConfig.plan.divisionDataSessionName,
      this.filterData.divisionData
    );
  }
  /* END */

  /* GET LIST BY CONDITION */
  async getPlanList() {
    this.pagination.totalPlans = 0;
    this.pagination.lastItemSeq = "-";
    this.pagination.offset =
      (this.pagination.currentPage - 1) * this.pagination.limit;
    this.searchParams.offset = this.pagination.offset;
    this.searchParams.planOptions = this.getChosenPlanOptions();

    /* GET PLAN LIST */
    this.tempData.loadingPlanList = true;
    let data = await this.planService.getPlanList(this.searchParams);
    this.planList = data.list;
    this.pagination.totalPlans = data.totalPlans;
    this.tempData.loadingPlanList = false;

    /* CALENDAR PRICES */
    if (this.monthJustChanged) {
      this.bestPriceList.thisMonth = data.price_calendar;
    }
    /* END */

    this.doPagination();

    /* SCROLL TO TOP */
    if (this.$(".plan").length > 0) {
      this.$("html, body").animate(
        { scrollTop: this.$(".plan").first().offset().top },
        350
      );
    }
    /* END */
  }

  /* HISTORY */
  getViewedPlans(event: any = {}) {
    let data = this.planService.getViewedPlans();
    if (data) {
      this.viewedPlans = data;
    }
  }

  /* FAVORITE */
  getFavouritePlans(event: any = {}) {
    let data = this.planService.getFavouritePlans();
    if (data) {
      this.favouritePlans = data;
    }
  }

  /* BELONGS TO CALENDAR */

  async getFilterCalendarPrices() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* THIS MONTH */
    let searchParams = {
      departureYMD: this.calendarDate,
      departureCityID: this.filterData.departureCityID,
      destinationCityID: this.filterData.destinationCityID,
      departureTownID: this.filterData.departureTownID,
      destinationTownID: this.filterData.destinationTownID,
      planOptions: this.getChosenPlanOptions(),
      sort: 1,
      offset: 0,
      limit: 1,
    };

    let thisMonth = searchParams.departureYMD;

    let searchParamsNextMonth = JSON.parse(JSON.stringify(searchParams));
    searchParamsNextMonth.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(1, "months")
      .format("YYYYMMDD");

    let searchParamsNext2Month = JSON.parse(JSON.stringify(searchParams));
    searchParamsNext2Month.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(2, "months")
      .format("YYYYMMDD");

    let searchParamsNext3Month = JSON.parse(JSON.stringify(searchParams));
    searchParamsNext3Month.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(3, "months")
      .format("YYYYMMDD");

    Promise.all([
      this.planService.getPlanList(searchParams),
      this.planService.getPlanList(searchParamsNextMonth),
      this.planService.getPlanList(searchParamsNext2Month),
      this.planService.getPlanList(searchParamsNext3Month),
    ]).then((data) => {
      this.filterData.bestPriceList.thisMonth = data[0].price_calendar;
      this.filterData.bestPriceList.nextMonth = data[1].price_calendar;
      this.filterData.bestPriceList.next2Month = data[2].price_calendar;
      this.filterData.bestPriceList.next3Month = data[3].price_calendar;

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    });
  }

  doPagination() {
    this.pagination.hasPrev = this.pagination.currentPage <= 1 ? false : true;
    this.pagination.hasNext =
      this.pagination.currentPage * this.pagination.limit <
      this.pagination.totalPlans
        ? true
        : false;
    this.pagination.lastItemSeq = this.pagination.offset + this.planList.length;
    /* COUNT this.pagination.hasPrevDay */
    if (
      this.moment(this.targetDay, "YYYYMMDD").valueOf() <=
      this.moment(this.moment(), "YYYYMMDD").valueOf()
    ) {
      this.pagination.hasPrevDay = false;
    } else {
      this.pagination.hasPrevDay = true;
    }
  }

  async getPrev() {
    if (this.pagination.hasPrev) {
      /* SHOW LOADER */
      this.commonService.showPageLoader("読み込み中...");

      this.pagination.currentPage--;
      await this.getPlanList();

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    }
  }

  async getNext() {
    if (this.pagination.hasNext) {
      /* SHOW LOADER */
      this.commonService.showPageLoader("読み込み中...");

      this.pagination.currentPage++;
      await this.getPlanList();

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    }
  }

  /* type 1: prev, 2: next */
  async getPreviousOrNextDay(type: number = 2) {
    let targetDay: any;
    if (type == 1) {
      if (!this.pagination.hasPrevDay) {
        return false;
      }
      targetDay = this.moment(this.targetDay)
        .subtract(1, "day")
        .format("YYYYMMDD");
    } else {
      targetDay = this.moment(this.targetDay).add(1, "day").format("YYYYMMDD");
    }

    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    this.targetDay = targetDay;
    this.hasTargetDay = true;
    this.viewingDate = targetDay;
    this.updateURL({ date: targetDay });

    /* GET LIST */
    this.pagination.currentPage = 1; /* BACK TO THE FIRST PAGE */
    this.searchParams.departureYMD = this.targetDay;
    this.monthJustChanged = true;
    await this.getPlanList();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  async onChooseDay(data: any) {
    if (
      this.bestPriceList.thisMonth.hasOwnProperty(data.date) ||
      this.bestPriceList.nextMonth.hasOwnProperty(data.date) ||
      this.filterData.bestPriceList.thisMonth.hasOwnProperty(data.date) ||
      this.filterData.bestPriceList.nextMonth.hasOwnProperty(data.date) ||
      this.filterData.bestPriceList.next2Month.hasOwnProperty(data.date) ||
      this.filterData.bestPriceList.next3Month.hasOwnProperty(data.date)
    ) {
      /* SHOW LOADER */
      this.commonService.showPageLoader("読み込み中...");

      let theDate = this.moment(data.date).format("YYYYMMDD");
      this.targetDay = theDate;
      this.viewingDate = theDate;
      this.filterData.targetDay = theDate;
      this.hasTargetDay = true;
      this.updateURL(data);

      /* GET LIST */
      this.pagination.currentPage = 1; /* BACK TO THE FIRST PAGE */
      this.searchParams.departureYMD = this.targetDay;
      this.monthJustChanged = data.monthJustChanged;
      await this.getPlanList();

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    }
  }

  async onDateChanged(data: any) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    this.targetDay = this.moment(data.date).format("YYYYMMDD");
    this.hasTargetDay = true;
    this.viewingDate = this.moment(data.date).format("YYYYMMDD");
    this.updateURL(data);

    /* GET LIST */
    this.pagination.currentPage = 1; /* BACK TO THE FIRST PAGE */
    this.searchParams.departureYMD = this.targetDay;
    this.monthJustChanged = data.monthJustChanged;
    await this.getPlanList();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  updateURL(data: any) {
    let route = ``;

    /* CITY */
    if (
      this.searchParams.departureCityID != "" ||
      this.searchParams.destinationCityID != ""
    ) {
      route +=
        this.searchParams.departureCityID != ""
          ? `${
              this.filterData.divisionData.division_map.id_bb[
                this.searchParams.departureCityID
              ].slug
            }_`
          : `_`;
      route +=
        this.searchParams.destinationCityID != ""
          ? `${
              this.filterData.divisionData.division_map.id_bb[
                this.searchParams.destinationCityID
              ].slug
            }/`
          : `/`;
    }

    /* TOWN */
    if (
      this.searchParams.departureTownID != "" ||
      this.searchParams.destinationTownID != ""
    ) {
      route +=
        this.searchParams.departureTownID != ""
          ? `${
              this.filterData.townData.departure.map.id_bb[
                this.searchParams.departureTownID
              ].slug
            }_`
          : `_`;
      route +=
        this.searchParams.destinationTownID != ""
          ? `${
              this.filterData.townData.destination.map.id_bb[
                this.searchParams.destinationTownID
              ].slug
            }/`
          : `/`;
    }

    /* DATE */
    route += `${this.moment(data.date).format("YYYYMMDD")}`;

    this.location.replaceState(
      `${this.commonService.routePaths.pagePlanListNoParam}/${route}`
    );
  }
  /* END */

  forceReload() {
    /* WORKAROUND FOR ROUTE CHANGED */
    setTimeout(function () {
      window.location.reload();
    }, 300);
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  /* INFINITE LOAD WHEN SCROLLING TO PAGE BOTTOM */
  public infiniteLoaded: boolean = true;

  async infiniteLoad() {
    if (this.infiniteLoaded && this.pagination.hasNext) {
      /* SET LOADING STATE */
      this.infiniteLoaded = false;

      this.pagination.currentPage++;
      this.pagination.offset =
        (this.pagination.currentPage - 1) * this.pagination.limit;
      this.searchParams.offset = this.pagination.offset;
      this.searchParams.planOptions = this.getChosenPlanOptions();

      /* GET PLAN LIST */
      let data = await this.planService.getPlanList(this.searchParams);
      this.planList = [...this.planList, ...data.list];

      this.doPagination();

      /* SET LOADING STATE */
      this.infiniteLoaded = true;
    }
  }

  inlineJS() {
    let self = this;

    self.$(function () {
      /* INFINITE LOADING SCROLL */
      let infiniteScrollOffset = 350; /* IN PIXELS */
      self.$(window).scroll(function () {
        if (
          self.$(window).scrollTop() + self.$(window).height() >=
          self.$(document).height() - infiniteScrollOffset
        ) {
          self.pagination.hasNext && self.infiniteLoad();
        }
      });
      /* END */

      /* SHOW/HIDE PAGING */
      let showFlag = false;
      let paging = self.$(".js-paging");
      paging.css("bottom", "-100px");

      //スクロールが100に達したらボタン表示
      self.$(window).scroll(function () {
        if (self.$(this).scrollTop() > 50) {
          if (showFlag == false) {
            showFlag = true;
            paging.stop().animate({ bottom: "110px" }, 800);
          }
        } else {
          if (showFlag) {
            showFlag = false;
            paging.stop().animate({ bottom: "-110px" }, 800);
          }
        }
      });
      /* END */

      /* CHECK PARENT MODAL IS STILL OPENED */
      self.$(document).on("hidden.bs.modal", ".modal", function () {
        if (self.$(".modal.show").length != 0) {
          self.$("body").addClass("modal-open");
        }
      });
      /* END */
    });
  }
}
